import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
export function useScrolledPast(t0) {
  const $ = _c(3);
  const threshold = t0 === undefined ? 0 : t0;
  const [past, setPast] = useState(false);
  let t1;
  let t2;
  if ($[0] !== threshold) {
    t1 = () => {
      const onScroll = () => setPast(window.scrollY > threshold);
      window.addEventListener("scroll", onScroll, {
        passive: true
      });
      onScroll();
      return () => window.removeEventListener("scroll", onScroll);
    };
    t2 = [threshold];
    $[0] = threshold;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return past;
}